
import SecuritySafe from "../../../assets/duotone/SecuritySafe.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SecuritySafeIcon({ className, dataTestid = "SecuritySafeIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <SecuritySafe data-testid={dataTestid} className={classes} {...rest} />
  );
}
